import React from 'react';
import { LoginForm } from './login-form';
import { Shield } from 'lucide-react';

export function LoginPage() {
  return (
    <div className="bg-muted flex min-h-screen flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <a href="#" className="flex items-center gap-2 self-center font-medium">
          <div className="bg-primary text-primary-foreground flex size-8 items-center justify-center rounded-md">
            <Shield className="size-5" />
          </div>
          <span className="text-xl font-semibold">Vault Secret Manager</span>
        </a>
        <LoginForm />
      </div>
    </div>
  );
}
